import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";
import React from "react";

type Props = {
    maxwidth?: number,
    minwidth?: number
}


export const CustomTooltip = styled( ({ className, ...props }: TooltipProps & Props) => (
            <Tooltip {...props} classes={{ popper: className }} />
    ))
  (({minwidth, maxwidth}) => ({
    
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: maxwidth,
      minWidth: minwidth
    },
  }));
  